export class EntityMappingTableDataResponse {

}